import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import plupload from 'plupload';
import { getFileInfo, checkFolderWritePermission, fetchUploadFileUrl, setUploadFileCommitInfo, setDeviceFileCommitInfo, loadFilePathToUpdate, loadFilePathNoUpdate } from '@kso/ui/lib/request';
import Message from 'element-ui/lib/message';
import 'element-ui/lib/theme-chalk/message.css';
import { t } from '@kso/ui/lib/config/locale';
import { getExtName, subFileName, getCloseParent, hasClass, klass, getRect, getSpaceFullType } from '@kso/ui/lib/utils';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import KIcon from '@kso/ui/lib/Icon';
import '@kso/ui/lib/Icon/style.css';
import { convertUnit, getFileIcon, isKaeRelease } from '@kso/util';
import VueAbbr from '@kso/ui/lib/VueAbbr';
import '@kso/ui/lib/VueAbbr/style.css';
import Emitter from 'element-ui/lib/mixins/emitter';
import { getHost, replaceLocHost, KDOCS } from '@kso/constants';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import dataset from 'dataset';
import MessageBox from 'element-ui/lib/message-box';
import 'element-ui/lib/theme-chalk/message-box.css';

var isSameType = function isSameType(oldName, newName) {
  return oldName.split('.').pop().toLowerCase() === newName.split('.').pop().toLowerCase();
};
var formatFile = function formatFile(file) {
  return {
    id: file.id,
    size: file.size,
    fname: file.fname,
    ftype: file.ftype,
    extname: file.extname,
    result: file.result,
    message: file.message || t('logic.Upload.uploadFail'),
    hasFolder: file.hasFolder,
    groupid: file.groupid,
    parentid: file.parentid,
    directory: file.directory,
    percent: file.percent,
    complete: file.complete,
    failed: file.failed || file.status === plupload.FAILED,
    uploading: file.failed || file.complete ? false : file.status < 5
  };
};
var uploadMixin = {
  methods: {
    initPLUpload: function initPLUpload() {
      this.PLUploader = new plupload.Uploader({
        url: 'url',
        multipart: true,
        multi_selection: false,
        // 是否支持选择多个文件
        send_file_name: false,
        runtimes: 'html5,flash',
        flash_swf_url: 's1/Moxie.swf',
        drop_element: 'uploader-dropzone',
        browse_button: '_plupload_button_',
        /*
         * PreInit events, bound before the internal events.
         * https://github.com/moxiecode/plupload/blob/master/examples/events.html
         */
        preinit: {
          /*
           * Fires when a file is to be uploaded by the runtime.
           * UploadFile: (uploader, file) => { dispatch(FILE_BEFORE_UPLOAD, { uploader, file }) }
           */
          UploadFile: this.doBeforeUpload
        },
        // Post init events, bound after the internal events.

        init: {
          // Fires for every filtered file before it is added to the queue.
          FileFiltered: this.onFileFiltered,
          // Fires after files were filtered and added to the queue.
          FilesAdded: this.onFileAdded,
          // Fires when a file is successfully uploaded.
          FileUploaded: this.onFileUploaded,
          // Fires while a file is being uploaded.
          UploadProgress: this.updateQueue,
          // Fires when all files in a queue are uploaded.
          UploadComplete: this.onFileComplete,
          Error: this.onFileError,
          FilesRemoved: this.onFileRemoved
        }
      });
      this.PLUploader.init();
    },
    getTeamInfo: function getTeamInfo() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$getFileInfo, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getFileInfo({
                groupid: _this.groupID
              });
            case 2:
              _yield$getFileInfo = _context.sent;
              data = _yield$getFileInfo.data;
              _this.teamInfo = data;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    checkFolderPermission: function checkFolderPermission() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var write, _yield$checkFolderWri, assert;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              /*
               * 在文件夹中才需要检查
               * 因为企业用户或者没有目录权限功能,所以不用走请求校验,直接拥有所有权限
               */
              write = !_this2.userInfo.is_plus;
              if (!(!_this2.folderID || _this2.deviceID)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", true);
            case 3:
              if (write) {
                _context2.next = 14;
                break;
              }
              _context2.prev = 4;
              _context2.next = 7;
              return checkFolderWritePermission({
                groupID: _this2.groupID,
                folderID: _this2.folderID
              });
            case 7:
              _yield$checkFolderWri = _context2.sent;
              assert = _yield$checkFolderWri.data.assert;
              if (assert) {
                write = true;
              }
              _context2.next = 14;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](4);
            case 14:
              if (!write) {
                Message({
                  type: 'error',
                  message: t('logic.Upload.err6')
                });
              }
              return _context2.abrupt("return", write);
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[4, 12]]);
      }))();
    },
    doBeforeUpload: function doBeforeUpload(uploader, file) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var targetFile, key, value, query, response, _ref, status, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              targetFile = file; // 已经获取过 uploadUrl
              if (!file.uploadUrl) {
                _context3.next = 7;
                break;
              }
              key = 'multipart_params';
              value = {
                'key': file.key,
                'Policy': file.Policy,
                'submit': 'Upload to KS3',
                'Signature': file.Signature,
                'KSSAccessKeyId': file.KSSAccessKeyId,
                'x-kss-newfilename-in-body': 'true',
                'x-kss-server-side-encryption': file['x-kss-server-side-encryption']
              };
              uploader.setOption(key, value);
              uploader.setOption('url', file.uploadUrl);
              return _context3.abrupt("return");
            case 7:
              // 暂停上传，先获取 uploadUrl
              uploader.stop();
              query = {
                groupid: file.groupid,
                parentid: file.parentid,
                parent_path: file.parentpath,
                size: file.size,
                name: file.fname
              };
              query.store = 'ks3';
              query.method = 'POST';
              query.encrypt = true;

              // 获取上传 url 和 验证信息
              _context3.next = 14;
              return fetchUploadFileUrl(query);
            case 14:
              response = _context3.sent;
              _ref = response || {}, status = _ref.status, data = _ref.data;
              if (!(status !== 200)) {
                _context3.next = 20;
                break;
              }
              targetFile.failed = true;
              _this3.triggerError(uploader, file, response || t('logic.Upload.err7'));
              return _context3.abrupt("return");
            case 20:
              targetFile.key = data.key;
              targetFile.uploadUrl = data.url;
              targetFile.Policy = data.Policy;
              targetFile.Signature = data.Signature;
              targetFile.KSSAccessKeyId = data.KSSAccessKeyId;
              targetFile['x-kss-server-side-encryption'] = data['x-kss-server-side-encryption'];
              uploader.start();
            case 27:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    onFileFiltered: function onFileFiltered(uploader, file) {
      file.timestamp = Date.now(); // 添加时间戳
      // file.routeFrom = rootState.globalStore.state.route.name // 添加路由来源
      var _this$path = this.path,
        groupid = _this$path.groupid,
        parentid = _this$path.parentid,
        filename = _this$path.filename,
        isNewVersion = _this$path.isNewVersion,
        directory = _this$path.directory;

      // 上传新版本，判断文件类型是否一致
      this.isMatchType = isSameType(filename, file.name);
      if (isNewVersion && filename && file.name && !this.isMatchType) {
        Message({
          type: 'warning',
          message: t('logic.Upload.err8')
        });
        uploader.removeFile(file.id);
        return;
      }

      // 获取父文件夹路径
      var fsource = file.getSource();
      var fnative = file.getNative();
      var relativePath = fsource && fsource.webkitRelativePath || fnative && fnative.webkitRelativePath || fsource && fsource.relativePath;
      if (relativePath.substr(0, 1) === '/') {
        relativePath = relativePath.substr(1);
      }
      var paths = relativePath.split('/');
      var parentpath = paths.length ? paths.slice(0, paths.length - 1) : '';

      // 挂载文件信息以便每个钩子访问
      file.groupid = groupid;
      file.parentid = parentid;
      file.parentpath = parentpath;
      file.ftype = 'file';
      file.fname = isNewVersion ? filename : file.name;
      file.extname = getExtName(file.fname, file.ftype);
      file.directory = directory;

      /*
       * 不上传空文件
       * 防止 size 为 udf 的情况下被转成 NaN
       */
      if (!file.size) {
        file.size = 0;
        this.triggerError(uploader, file, t('logic.Upload.err9'));
      }
    },
    onFileAdded: function onFileAdded(uploader, files) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var canUpload, isShow;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // 设备目录不支持上传文件夹
              if (_this4.deviceID && files.length > 1 && files.some(function (f) {
                return f.parentpath.length > 0;
              })) {
                files.forEach(function (f) {
                  f.hasFolder = true;
                });
              }
              // 上传之前先检查是否有该文件夹的操作权限
              _context4.next = 3;
              return _this4.checkFolderPermission();
            case 3:
              canUpload = _context4.sent;
              if (canUpload) {
                _context4.next = 6;
                break;
              }
              return _context4.abrupt("return");
            case 6:
              // 显示上传面板
              isShow = _this4.path.isNewVersion ? _this4.isMatchType : true;
              if (isShow && _this4.config.enableMultiple !== false) {
                _this4.showPanel(true);
              }
              _this4.singleUploading = true;
              uploader.start();
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    onFileUploaded: function onFileUploaded(uploader, file, result) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var targetFile, response, responseHeaders, fileInfo, isNewVersion, fileid, res, etag, etagIndex, fileData, rsp, deviceid, _rsp, data, status, success, _file;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              targetFile = file;
              response = result.response, responseHeaders = result.responseHeaders;
              fileInfo = _this5.path || {};
              isNewVersion = fileInfo.isNewVersion, fileid = fileInfo.fileid;
              res = JSON.parse(response); // etag由服务端在responseHeaders填写，该参数值为MD5，长度为32
              etagIndex = responseHeaders.indexOf('etag: "') === -1 ? responseHeaders.indexOf('ETag: "') === -1 ? 0 : responseHeaders.indexOf('ETag: "') + 7 : responseHeaders.indexOf('etag: "') + 7;
              etag = etagIndex ? responseHeaders.substr(etagIndex, 32) : '';
              if (!(res.stat === 'ERR_BAD_FORM_DATA')) {
                _context5.next = 9;
                break;
              }
              return _context5.abrupt("return");
            case 9:
              fileData = {
                groupid: file.groupid,
                parentid: file.parentid,
                parent_path: file.parentpath,
                name: file.fname,
                isUpNewVer: isNewVersion,
                etag: etag || ''
              };
              if (isNewVersion) {
                fileData.fileid = fileid;
              }
              fileData.store = 'ks3';
              fileData.size = file.size;
              fileData.sha1 = res.newfilename;
              if (!(_this5.deviceID && !file.hasFolder)) {
                _context5.next = 21;
                break;
              }
              deviceid = _this5.deviceID;
              _context5.next = 18;
              return setDeviceFileCommitInfo(Object.assign(fileData, {
                deviceid: deviceid
              }), isNewVersion);
            case 18:
              rsp = _context5.sent;
              _context5.next = 24;
              break;
            case 21:
              _context5.next = 23;
              return setUploadFileCommitInfo(fileData, isNewVersion);
            case 23:
              rsp = _context5.sent;
            case 24:
              _rsp = rsp, data = _rsp.data, status = _rsp.status;
              success = status === 200;
              if (!(!success || !data)) {
                _context5.next = 31;
                break;
              }
              targetFile.complete = false;
              targetFile.failed = true;
              // dispatch(TRIGGER_ERROR, { uploader, file, error: rsp })
              _this5.updateQueue(uploader);
              return _context5.abrupt("return");
            case 31:
              // 更新操作列表
              if (data && status === 200 && fileData.parent_path) {
                _file = {
                  fileid: data.id || data.fileid,
                  groupid: fileData.groupid,
                  parentid: fileData.parentid,
                  parentpath: fileData.parent_path
                };
                _this5.updateList(_file);
              }
              targetFile.parentid = data.parentid;
              targetFile.id = data.id;
              targetFile.complete = true;
              _this5.updateQueue(uploader);
              _this5.$emit('success', targetFile);
            case 37:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    onFileError: function onFileError(uploader, error) {
      if (error.code === -600) {
        Message({
          type: 'error',
          message: t('logic.Upload.err10')
        });
      }
      if (error.message === t('logic.Upload.err9')) {
        error.message = 'emptyFile';
      }
    },
    onFileRemoved: function onFileRemoved(uploader, files) {
      var _this6 = this;
      var manualCancelFiles = files.filter(function (file) {
        return _this6.manualCancelIDs.find(function (id) {
          return id === file.id;
        });
      });
      this.removedFiles = this.removedFiles.concat(manualCancelFiles.map(function (file) {
        return Object.assign(formatFile(file), {
          message: t('logic.Upload.canceled'),
          complete: false,
          failed: true,
          uploading: false,
          timestamp: file.timestamp
        });
      }));
    },
    onFileComplete: function onFileComplete(uploader) {
      this.singleUploading = false;
      this.updateQueue(uploader);
    },
    updateQueue: function updateQueue(uploader) {
      uploader.refresh();
      var total = this.total;
      var removedFiles = this.removedFiles;
      var totalTemp = {
        queued: 0,
        loaded: 0,
        failed: 0,
        uploaded: 0
      };

      // 更新 Panel 的上传总数状态
      Object.keys(totalTemp).forEach(function (key) {
        if (key === 'uploaded') {
          total.success = uploader.total[key] || 0;
        } else if (key === 'queued') {
          total.queue = uploader.total[key] || 0;
        } else if (key === 'failed') {
          total.fail = (uploader.total[key] || 0) + removedFiles.length;
        }
      });
      this.total = total;

      // 更新 Panel 的文件数据
      var files = [];
      uploader.files.forEach(function (file) {
        files.push(Object.assign(formatFile(file), {
          timestamp: file.timestamp
        }));
      });
      this.files = files.concat(removedFiles).sort(function (n1, n2) {
        return n1.timestamp - n2.timestamp;
      });
    },
    setUploadPath: function setUploadPath(path) {
      var newPath = this.path;
      Object.keys(newPath).forEach(function (key) {
        if (key in path) {
          newPath[key] = path[key];
        }
      });
      this.path = newPath;
    },
    triggerError: function triggerError(uploader, file, error) {
      var message;
      var result;
      if (typeof error === 'string') {
        message = result = error;
      } else if (error && error.data) {
        message = error.data.msg;
        result = error.data.result;
      } else {
        message = result = error.message;
      }
      uploader.trigger('Error', {
        file: file,
        message: message,
        code: plupload.HTTP_ERROR
      });
      file.result = result;
      file.message = message;
      if (this.config.enableMultiple === false) {
        Message.error(message);
      }
      setTimeout(function () {
        uploader.start();
      }, 200);
    },
    updateList: function updateList(file) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var fileid, groupid, parentid, path, hasUpdatedPaths, response, data, status, newFileId, paths, fileIndex;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              fileid = +file.fileid;
              groupid = +file.groupid;
              parentid = +file.parentid;
              path = groupid + '/' + parentid + '/' + file.parentpath;
              hasUpdatedPaths = _this7.hasUpdatedPaths;
              if (!(hasUpdatedPaths.indexOf(path) > -1)) {
                _context6.next = 7;
                break;
              }
              return _context6.abrupt("return");
            case 7:
              // 标记已经更新过
              hasUpdatedPaths.push(path);
              _this7.hasUpdatedPaths = hasUpdatedPaths;
              _context6.next = 11;
              return loadFilePathNoUpdate(fileid);
            case 11:
              response = _context6.sent;
              data = response.data, status = response.status;
              if (!(data && status === 200 && data.path.length)) {
                _context6.next = 18;
                break;
              }
              paths = data.path; // 根目录操作
              if (paths.length === 1) {
                newFileId = paths[0].fileid;
              } else {
                fileIndex = paths.length - 1;
                paths.forEach(function (path, index) {
                  if (path.fileid === parentid) {
                    fileIndex = index + 1;
                  }
                });
                newFileId = paths[fileIndex].fileid;
              }
              _context6.next = 18;
              return loadFilePathToUpdate({
                groupid: groupid,
                fileid: newFileId
              });
            case 18:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    }
  }
};

var Title = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "k-upload-title",
      "class": {
        'shrink': _vm.fold
      }
    }, [_c('strong', {
      staticClass: "info-text"
    }, [_c('span', [_vm._v(_vm._s(_vm.titles.mainTitle))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.titles.subTitle))])]), _vm._v(" "), _c('div', {
      staticClass: "button-wrapper"
    }, [_c('div', {
      staticClass: "button-common shrink-button",
      "class": {
        'rotate': _vm.fold
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('toggle');
        }
      }
    }, [_c('KIcon', {
      attrs: {
        "type": "minimize"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "button-common",
      on: {
        "click": function click($event) {
          return _vm.$emit('close');
        }
      }
    }, [_c('KIcon', {
      attrs: {
        "type": "close"
      }
    })], 1)])]);
  },
  staticRenderFns: [],
  name: 'KUploadTitle',
  components: {
    KIcon: KIcon
  },
  props: {
    titles: {
      type: Object,
      "default": function _default() {
        return {
          mainTitle: '',
          subTitle: ''
        };
      },
      validator: function validator(o) {
        var M = function M(v, h) {
          return Object.prototype.toString.call(v).slice(8, -1) === String(h);
        };
        var T = {
          str: 'String',
          num: 'Number',
          boo: 'Boolean',
          obj: 'Object'
        };
        var V = Object.entries(o).filter(function (i) {
          var R = true;
          var _i = _slicedToArray(i, 2),
            k = _i[0],
            v = _i[1];
          switch (k) {
            case 'mainTitle':
              R = M(v, T.str);
              break;
            case 'subTitle':
              R = M(v, T.str);
              break;
          }
          return !R;
        });
        return V.length === 0;
      }
    },
    fold: {
      type: Boolean,
      "default": false
    }
  }
};

var Body = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      ref: "panelBody",
      staticClass: "k-upload-body",
      on: {
        "scroll": function scroll($event) {
          $event.stopPropagation();
          return _vm.scrollPanel($event);
        }
      }
    }, [_vm._t("default")], 2);
  },
  staticRenderFns: [],
  name: 'KUploadBody',
  props: {
    filesInfo: {
      type: Object,
      "default": function _default() {
        return {
          filesLen: 0,
          loadedLen: 0
        };
      },
      validator: function validator(o) {
        var M = function M(v, h) {
          return Object.prototype.toString.call(v).slice(8, -1) === String(h);
        };
        var T = {
          str: 'String',
          num: 'Number',
          boo: 'Boolean',
          obj: 'Object'
        };
        var V = Object.entries(o).filter(function (i) {
          var R = true;
          var _i = _slicedToArray(i, 2),
            k = _i[0],
            v = _i[1];
          switch (k) {
            case 'filesLen':
              R = M(v, T.num);
              break;
            case 'loadedLen':
              R = M(v, T.num);
              break;
          }
          return !R;
        });
        return V.length === 0;
      }
    }
  },
  data: function data() {
    return {
      lastPercent: 0,
      lastScroll: 0,
      lastloadInfo: {
        // 记录最后一次完成导出或上传文件的信息
        filesLen: 0,
        loaded: false
      },
      singleHeight: 67
    };
  },
  watch: {
    filesInfo: function filesInfo() {
      this.scrollBar();
    }
  },
  methods: {
    // 控制滚动条位置，待优化
    scrollBar: function scrollBar() {
      var _this = this;
      var interval = Date.now() - this.lastScroll;
      var filesLen = this.filesInfo.filesLen;
      var loadedLen = this.filesInfo.loadedLen;
      if (this.lastloadInfo.filesLen === filesLen && this.lastloadInfo.loaded) {
        return;
      }
      if (interval > 50) {
        if (loadedLen <= filesLen) {
          window.requestAnimationFrame(function () {
            _this.$refs.panelBody.scrollTop = loadedLen * _this.singleHeight;
          });
        }
        if (loadedLen === filesLen) {
          this.lastloadInfo.filesLen = filesLen;
          this.lastloadInfo.loaded = true;
        }
      }
    },
    scrollPanel: function scrollPanel() {
      this.lastScroll = Date.now();
    }
  }
};

var Row = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', [_vm.isSingleFile ? _c('div', {
      staticClass: "k-upload-row-single"
    }, [!_vm.fileInfo.failed ? _c('span', {
      staticClass: "fstatus"
    }, [_vm.fileInfo.loading ? _c('div', {
      staticClass: "fstatus-loading"
    }, [_c('div', {
      staticClass: "loading-wrapper"
    }, [_c('div', {
      staticClass: "wrapper right"
    }, [_c('div', {
      staticClass: "circleProgress rightcircle",
      style: {
        transform: "rotate(" + _vm.leftdeg + "deg)"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrapper left"
    }, [_c('div', {
      staticClass: "circleProgress leftcircle",
      style: {
        transform: "rotate(" + _vm.rightdeg + "deg)"
      }
    })])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "text-waiting"
    }, [_vm._v(_vm._s(_vm.lang_opening))]), _vm._v(" "), _c('KIcon', {
      staticClass: "btn-close",
      attrs: {
        "type": "close"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.$emit('cancelTask', _vm.fileInfo.origin);
        }
      }
    })], 1) : _c('div', {
      staticClass: "k-upload-row",
      "class": {
        'failed': _vm.fileInfo.failed,
        'space-full': _vm.fileInfo.spaceFullErr,
        'size-limit': _vm.fileInfo.sizeLimitErr && _vm.fileInfo.fsize <= 1073741824,
        'success': _vm.fileInfo.success
      },
      on: {
        "click": _vm.errHandler
      }
    }, [_c('div', {
      staticClass: "finfo",
      on: {
        "mouseenter": function mouseenter($event) {
          $event.stopPropagation();
          return _vm.toggleLoadedText(true);
        },
        "mouseleave": function mouseleave($event) {
          $event.stopPropagation();
          return _vm.toggleLoadedText(false);
        }
      }
    }, [_c('span', {
      staticClass: "ficon"
    }, [_c('KIcon', {
      attrs: {
        "type": _vm.getFileIcon(_vm.fileInfo.fname, _vm.fileInfo.ftype)
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "fmain"
    }, [_c('div', {
      staticClass: "fname"
    }, [_c('vue-abbr', {
      attrs: {
        "text": _vm.subFileName(_vm.fileInfo.fname)
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "fsize"
    }, [_c('span', [_vm._v(_vm._s(_vm.convertUnit(_vm.fileInfo.fsize)))])])]), _vm._v(" "), _c('span', {
      staticClass: "faction",
      "class": {
        'faction-fail-row': _vm.fileInfo.failed,
        'faction-fail-detail': _vm.isUIUploadFileDetails && (_vm.fileInfo.spaceFullErr || _vm.fileInfo.sizeLimitErr && _vm.fileInfo.fsize <= 1073741824)
      }
    }, [_vm.fileInfo.failed ? _c('span', {
      staticClass: "faction-fail"
    }, [_vm._v(_vm._s(_vm.fileInfo.error))]) : _vm.fileInfo.success ? _c('span', {
      staticClass: "faction-complete",
      on: {
        "click": function click($event) {
          return _vm.$emit('traceFileInFolder', _vm.fileInfo.origin);
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.mousehover,
        expression: "mousehover"
      }]
    }, [_vm._t("successHover")], 2)]) : _vm.fileInfo.loading ? _c('span', {
      staticClass: "faction-cancel",
      on: {
        "click": function click($event) {
          return _vm.$emit('cancelTask', _vm.fileInfo.origin);
        }
      }
    }, [_vm._v(_vm._s(_vm.lang_cancel))]) : _c('span')]), _vm._v(" "), !_vm.fileInfo.failed ? _c('span', {
      staticClass: "fstatus"
    }, [_vm.fileInfo.success ? _c('KIcon', {
      staticClass: "fstatus-success",
      attrs: {
        "type": "success"
      }
    }) : _vm.fileInfo.failed ? _c('KIcon', {
      staticClass: "fstatus-exclamation",
      attrs: {
        "type": "warning"
      }
    }) : _vm.fileInfo.loading ? _c('div', {
      staticClass: "fstatus-loading"
    }, [_c('div', {
      staticClass: "loading-wrapper"
    }, [_c('div', {
      staticClass: "wrapper right"
    }, [_c('div', {
      staticClass: "circleProgress rightcircle",
      style: {
        transform: "rotate(" + _vm.leftdeg + "deg)"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wrapper left"
    }, [_c('div', {
      staticClass: "circleProgress leftcircle",
      style: {
        transform: "rotate(" + _vm.rightdeg + "deg)"
      }
    })])])]) : _vm._e()], 1) : _vm._e()])])]);
  },
  staticRenderFns: [],
  name: 'KUploadRow',
  components: {
    VueAbbr: VueAbbr,
    KIcon: KIcon
  },
  mixins: [Emitter],
  props: {
    isSingleFile: Boolean,
    fileInfo: {
      type: Object,
      "default": function _default() {
        return {
          ftype: '',
          fname: '',
          fsize: 0,
          error: '',
          percent: 0,
          failed: true,
          success: false,
          loading: false,
          spaceFullErr: {},
          origin: {} // 原始file数据
        };
      },
      validator: function validator(o) {
        var M = function M(v, h) {
          return Object.prototype.toString.call(v).slice(8, -1) === String(h);
        };
        var T = {
          str: 'String',
          num: 'Number',
          boo: 'Boolean',
          obj: 'Object'
        };
        var V = Object.entries(o).filter(function (i) {
          var R = true;
          var _i = _slicedToArray(i, 2),
            k = _i[0],
            v = _i[1];
          switch (k) {
            case 'ftype':
              R = M(v, T.str);
              break;
            case 'fname':
              R = M(v, T.str);
              break;
            case 'fsize':
              R = M(v, T.num);
              break;
            case 'error':
              R = M(v, T.str);
              break;
            case 'percent':
              R = M(v, T.num);
              break;
            case 'failed':
              R = M(v, T.boo);
              break;
            case 'success':
              R = M(v, T.boo);
              break;
            case 'loading':
              R = M(v, T.boo);
              break;
            case 'origin':
              R = M(v, T.obj);
              break;
            case 'spaceFullType':
              R = M(v, T.str);
              break;
          }
          return !R;
        });
        return V.length === 0;
      }
    }
  },
  data: function data() {
    return {
      lang_opening: t('logic.Upload.opening'),
      lang_cancel: t('logic.Upload.cancel'),
      mousehover: false
    };
  },
  computed: {
    isUIUploadFileDetails: function isUIUploadFileDetails() {
      return this.$__SHIELD_CONFIG__ ? this.$__SHIELD_CONFIG__.UIUploadFileDetails : true;
    },
    leftdeg: function leftdeg() {
      var percent = this.fileInfo.percent;
      var deg = percent >= 50 ? 180 : 0;
      if (percent > 0 && percent < 50) {
        deg = Math.ceil(180 * percent / 50);
      }
      return deg;
    },
    rightdeg: function rightdeg() {
      var percent = this.fileInfo.percent;
      var deg = percent < 100 ? 180 : 360;
      if (percent > 50 && percent < 100) {
        deg = Math.ceil(360 * percent / 100);
      }
      return deg;
    }
  },
  methods: {
    convertUnit: convertUnit,
    subFileName: subFileName,
    getFileIcon: getFileIcon,
    // 控制成功加载后的文案显示
    toggleLoadedText: function toggleLoadedText(val) {
      this.mousehover = val;
    },
    errHandler: function errHandler() {
      if (this.config.enableMultiple === false) {
        return;
      }
      var _this$fileInfo = this.fileInfo,
        spaceFullErr = _this$fileInfo.spaceFullErr,
        failed = _this$fileInfo.failed,
        sizeLimitErr = _this$fileInfo.sizeLimitErr,
        fsize = _this$fileInfo.fsize,
        success = _this$fileInfo.success,
        origin = _this$fileInfo.origin;
      if (failed && spaceFullErr) {
        var msg = t('logic.Upload.err0');
        if (spaceFullErr === 'MySpaceFull') {
          msg = t('logic.Upload.err2');
        } else if (spaceFullErr === 'GroupOwnerSpaceFull') {
          msg = t('logic.Upload.err2');
        }
        Message({
          type: 'error',
          message: msg
        });
        /*
         * this.$parent.onError({
         *   result: spaceFullErr,
         *   msg
         * })
         */
      } else if (failed && sizeLimitErr && fsize <= 1073741824) {
        Message({
          type: 'error',
          message: t('logic.Upload.err4')
        });
        /*
         * this.$parent.onError({
         *   result: 'sizeLimit',
         *   msg: '文件大小超过限制'
         * })
         */
      } else if (success) {
        try {
          var whitelist = ['www.kdocs.cn', 'docs.wps.cn'];
          if (isKaeRelease('oem')) {
            whitelist = [getHost('kdocs')];
          }
          if (whitelist.includes(location.hostname)) {
            window.open(replaceLocHost("/p/".concat(origin.id)));
          } else {
            window.open("".concat(KDOCS, "/p/").concat(origin.id));
          }
        } catch (e) {
          if (e.response && e.response.data && e.response.data.msg) {
            this._error(e.response.data.msg);
          }
        }
      }
    }
  }
};

var PlupDrop = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.outerVisible,
        expression: "outerVisible"
      }],
      ref: "uploader",
      staticClass: "k-upload-uploader",
      on: {
        "!dragleave": function dragleave($event) {
          return _vm.hideDropZone($event);
        }
      }
    }, [_c('div', {
      staticClass: "content",
      on: {
        "!drop": function drop($event) {
          return _vm.dropHandler($event);
        }
      }
    }, [_c('div', {
      staticClass: "dropzone-outer",
      attrs: {
        "id": "uploader-dropzone"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "uploader-tip"
    }, [_c('KIcon', {
      attrs: {
        "type": "upload-s"
      }
    }), _vm._v("\n      " + _vm._s(_vm.lang_uploadFile) + "\n    ")], 1)])]);
  },
  staticRenderFns: [],
  name: 'KUploadDropZone',
  components: {
    KIcon: KIcon
  },
  mixins: [Emitter],
  data: function data() {
    return {
      lang_uploadFile: t('logic.Upload.uploadFile'),
      outerVisible: false
    };
  },
  computed: {
    tooltipsPermission: function tooltipsPermission() {
      return this.$parent.tooltipsPermission;
    },
    groupid: function groupid() {
      return this.$parent.groupID;
    },
    folderid: function folderid() {
      return this.$parent.folderID;
    },
    disabled: function disabled() {
      return this.$parent.config.enableDrag === false;
    },
    teamInfo: function teamInfo() {
      return this.$parent.teamInfo;
    }
  },
  mounted: function mounted() {
    var el = document.querySelector('.k-upload-uploader');
    if (el && el.parentNode === document.body) {
      document.body.removeChild(el);
    }
    document.body.appendChild(this.$refs.uploader);

    // enter的时候就触发拖拽上传的遮罩，可以立马触发上传
    document.body.addEventListener('dragenter', this.handleDragenter);

    // 统一处理拖拽的默认事件
    document.addEventListener('dragenter', this.cancelDefaultEvent);
    document.addEventListener('dragover', this.cancelDefaultEvent);
    document.addEventListener('drop', this.cancelDefaultEvent);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('dragenter', this.handleDragenter);
  },
  methods: {
    handleDragenter: function handleDragenter(e) {
      // 禁用、只读成员或非文档区域 屏蔽拖拽上传
      if (this.disabled || !this.tooltipsPermission) {
        return;
      }
      var types = e.dataTransfer.types;
      // 只有从资源管理器拖拽进来的文件才触发
      if (~_toConsumableArray(types).indexOf('Files')) {
        var isNewVersion = false;
        var groupid = this.groupid;
        var parentid = this.folderid;

        // 设置数据到父（上传）组件
        this.setPath({
          groupid: groupid,
          parentid: parentid,
          isNewVersion: isNewVersion
        });
        e.dataTransfer.dropEffect = 'copy';
        this.showDropZone();
      }
    },
    dropHandler: function dropHandler(e) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var types;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.hideDropZone();
              types = e.dataTransfer.types;
              /*
               * const {name} = this.$store.state.route
               * const filesList = e.dataTransfer.files
               * let files = []
               * for (let file in filesList) {
               *   if (file && Object.prototype.toString.call(filesList[file]).slice(8, -1) === 'File') {
               *     files.push(filesList[file])
               *   }
               * }
               */
              if (~_toConsumableArray(types).indexOf('Files')) {
                // 私密文件夹过期
                if (_this.teamInfo.type === 'secret' && _this.isSecretExpired) {
                  _this.cancelDefaultEvent(e);
                  Message({
                    type: 'error',
                    message: t('logic.Upload.err5')
                  });
                  /*
                   * this.$parent.onError({
                   *   result: 'secretExpire',
                   *   msg: '你的会员已过期，无法使用私密文件夹功能，请续费后使用'
                   * })
                   */
                } else if (!_this.tooltipsPermission) {
                  // 没有上传权限
                  _this.cancelDefaultEvent(e);
                  Message({
                    type: 'error',
                    message: t('logic.Upload.err6')
                  });
                  /*
                   * this.$parent.onError({
                   *   result: 'secretExpire',
                   *   msg: '没有当前目录的操作权限,请联系管理员'
                   * })
                   */
                }
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    hideDropZone: function hideDropZone() {
      this.outerVisible = false;
    },
    showDropZone: function showDropZone() {
      this.outerVisible = true;
    },
    setPath: function setPath(path) {
      this.$parent.setUploadPath(path);
    },
    cancelDefaultEvent: function cancelDefaultEvent(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
};

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

// 上传按钮初始位置和大小
var getInitStyle = function getInitStyle() {
  return {
    width: '0',
    height: '0'
  };
};

// 移除上一个 hover 状态
var removeFadeHoverClass = function removeFadeHoverClass(excuteEl) {
  var anchors = document.querySelectorAll('.fade-uploader-back-hover');
  var _iterator = _createForOfIteratorHelper(anchors),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var anchor = _step.value;
      if (excuteEl !== anchor) {
        klass.removeClass(anchor, 'fade-uploader-back-hover');
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};
var ANCHOR_CLASS = 'plupload-anchor';
var PlupButton = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "uploader-button",
      style: _vm.style,
      on: {
        "!click": function click($event) {
          if ($event.target !== $event.currentTarget) {
            return null;
          }
          return _vm.onCheckPermissions($event);
        }
      }
    }, [_c('button', {
      staticClass: "upload-input",
      attrs: {
        "id": "_plupload_button_"
      }
    })]);
  },
  staticRenderFns: [],
  name: 'KUploadButton',
  mixins: [Emitter],
  data: function data() {
    return {
      style: getInitStyle(),
      hasIdentify: false,
      hoverEl: null
    };
  },
  computed: {
    tooltipsPermission: function tooltipsPermission() {
      return this.$parent.tooltipsPermission;
    },
    isSecretExpired: function isSecretExpired() {
      return this.$parent.isSecretExpired;
    },
    groupid: function groupid() {
      return this.$parent.groupID;
    },
    folderid: function folderid() {
      return this.$parent.folderID;
    },
    disabled: function disabled() {
      return this.$parent.config.enableButton === false;
    },
    teamInfo: function teamInfo() {
      return this.$parent.teamInfo;
    }
  },
  // 组件内部数据
  created: function created() {
    this.cover = false;
    this.isFolder = false;
  },
  mounted: function mounted() {
    // 注册全局事件，在处理中匹配到响应点击上传事件的元素
    document.addEventListener('mouseover', this.eventMouseOver);
    document.addEventListener('mouseout', this.eventMouseOut);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('mouseover', this.eventMouseOver);
    document.removeEventListener('mouseout', this.eventMouseOut);
  },
  methods: {
    setPath: function setPath(path) {
      this.$parent.setUploadPath(path);
    },
    eventMouseOver: function eventMouseOver(evt) {
      var hoverEl = getCloseParent(evt.target, '.' + ANCHOR_CLASS);
      if (hasClass(evt.target, ANCHOR_CLASS)) {
        hoverEl = evt.target;
      }
      if (this.disabled || !hoverEl) {
        return;
      }

      // 获取上传新版本的文件信息
      var fileid = dataset(hoverEl, 'fileid') || 0;
      var groupid = dataset(hoverEl, 'groupid') || 0;
      var parentid = dataset(hoverEl, 'parentid') || 0;
      var filename = dataset(hoverEl, 'filename') || '';
      var isNewVersion = !!(groupid && filename);

      // 非上传新版本的，直接从全局 state 获取目录信息
      if (!isNewVersion) {
        groupid = this.groupid;
        parentid = this.folderid;
      }

      // 是否上传文件夹
      this.isFolder = !!dataset(hoverEl, 'folder');

      // 是否有 hover 模拟
      var hasFadeHover = dataset(hoverEl, 'hover');

      // 设置数据到父（上传）组件
      this.setPath({
        fileid: fileid,
        groupid: groupid,
        parentid: parentid,
        filename: filename,
        isNewVersion: isNewVersion
      });
      if (hasFadeHover) {
        klass.addClass(hoverEl, 'fade-uploader-back-hover');
        removeFadeHoverClass(hoverEl);
      }

      // 根据触发元素定位上传按钮的位置和尺寸
      var rect = getRect(hoverEl);
      this.style = {
        width: rect.width + 'px',
        height: rect.height + 'px'
      };
      this.cover = true;
      if (!hoverEl.contains(this.$el)) {
        hoverEl.appendChild(this.$el);
      }
      this.hoverEl = hoverEl;
    },
    eventMouseOut: function eventMouseOut(evt) {
      var outEl = evt.target;
      removeFadeHoverClass(outEl);
      if (!this.cover || this.$el.contains(outEl) || klass.hasClass(outEl, ANCHOR_CLASS)) {
        return;
      }
      if (this.hoverEl) {
        // document.body.appendChild(this.$el)
        this.hoverEl = null;
      }
      this.cover = false;
      this.style = getInitStyle();
    },
    clickUpload: function clickUpload() {},
    onCheckPermissions: function onCheckPermissions() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.isSecretExpired) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _this.basicUploadProcess();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    basicUploadProcess: function basicUploadProcess() {
      if (!this.tooltipsPermission && !this.hasIdentify) {
        this.handleUploadPermission();
      } else {
        this.hasIdentify = false;
        this.triggerUpload();
      }
      this.clickUpload();
    },
    handleUploadPermission: function handleUploadPermission() {
      Message({
        type: 'error',
        message: t('logic.Upload.err6')
      });
      /*
       * this.$parent.onError({
       *   result: 'permissionDeny',
       *   msg: '没有当前目录的操作权限,请联系管理员'
       * })
       */
    },
    triggerUpload: function triggerUpload() {
      var moxie = this.$el.querySelector('.moxie-shim');
      if (moxie) {
        var button = moxie.querySelector('input');
        if (button) {
          if (this.isFolder) {
            // 添加 directory 属性支持上传文件夹
            button.setAttribute('webkitdirectory', '');
            button.setAttribute('directory', '');
            button.removeAttribute('value');
          } else {
            button.removeAttribute('webkitdirectory');
            button.removeAttribute('directory');
            button.setAttribute('value', 'C:/Users/89Y64N2/');
          }
          button.click();
        }
      }
    }
  }
};

var Upload = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "k-upload"
    }, [_vm.config.enableMultiple !== false ? _c('div', {
      staticClass: "container upload-container",
      "class": {
        fold: _vm.uploadFold
      },
      style: _vm.uploadStyle
    }, [_c('tooltip-title', {
      attrs: {
        "titles": _vm._f("formatTitle")(_vm.total),
        "fold": _vm.uploadFold
      },
      on: {
        "close": _vm.onClose,
        "toggle": _vm.onToggle
      }
    }), _vm._v(" "), _c('tooltip-body', {
      attrs: {
        "filesInfo": _vm._f("formatFilesInfo")(_vm.total)
      }
    }, _vm._l(_vm.files, function (file, index) {
      return _c('tooltip-row', {
        key: index,
        attrs: {
          "fileInfo": _vm._f("formatFile")(file)
        },
        on: {
          "cancelTask": function cancelTask($event) {
            return _vm.onCancelTask(arguments);
          }
        }
      }, [_c('span', {
        attrs: {
          "slot": "successHover"
        },
        slot: "successHover"
      }, [_vm._v(_vm._s(_vm.lang_open))])]);
    }), 1)], 1) : _vm.singleFile && _vm.singleUploading ? _c('div', {
      staticClass: "k-upload-single-file",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    }, [_c('tooltip-row', {
      attrs: {
        "fileInfo": _vm._f("formatFile")(_vm.singleFile),
        "isSingleFile": true
      },
      on: {
        "cancelTask": function cancelTask($event) {
          return _vm.onCancelTask(arguments);
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('PlupButton'), _vm._v(" "), _c('PlupDrop')], 1);
  },
  staticRenderFns: [],
  name: 'KUpload',
  componentName: 'KUpload',
  components: {
    TooltipTitle: Title,
    TooltipBody: Body,
    TooltipRow: Row,
    PlupDrop: PlupDrop,
    PlupButton: PlupButton
  },
  filters: {
    formatTitle: function formatTitle(total) {
      var titles = {};
      var text = t('logic.Upload.upload');
      var queue = total.queue,
        success = total.success,
        fail = total.fail;
      var completed = success + fail;
      var all = queue + success + fail;
      var current = success || fail ? queue ? completed + 1 : completed : 0;
      if (!queue && completed && fail) {
        titles = {
          mainTitle: "".concat(text).concat(t('logic.Upload.complete')),
          subTitle: "".concat(fail, " ").concat(t('logic.Upload.txt0'))
        };
      } else if (!queue && completed) {
        titles = {
          mainTitle: "".concat(text).concat(t('logic.Upload.complete')),
          subTitle: ''
        };
      } else if (queue) {
        titles = {
          mainTitle: "".concat(t('logic.Upload.txt1')).concat(text),
          subTitle: "".concat(current, "/").concat(all)
        };
      } else {
        titles = {
          mainTitle: "".concat(t('logic.Upload.file')).concat(text),
          subTitle: ''
        };
      }
      return titles;
    },
    formatFilesInfo: function formatFilesInfo(total) {
      return {
        filesLen: Object.values(total).reduce(function (cur, pre) {
          return cur + pre;
        }),
        loadedLen: total.success + total.fail
      };
    },
    formatFile: function formatFile(file) {
      var error = '';
      var spaceFullErr = '';
      var sizeLimitErr = '';
      if (file.result === 'SpaceFull') {
        var spaceFullType = getSpaceFullType(file.message);
        spaceFullErr = Object.assign({}, file, {
          msg: file.message
        });
        switch (spaceFullType) {
          case 'MySpaceFull':
            error = t('logic.Upload.err1');
            break;
          case 'GroupOwnerSpaceFull':
            error = t('logic.Upload.err2');
            break;
          default:
            error = file.message;
        }
      } else if (file.result === 'fileSizeLimit') {
        sizeLimitErr = Object.assign({}, file, {
          msg: file.message
        });
        if (file.size > 1073741824) {
          error = t('logic.Upload.err3');
        } else {
          error = file.message;
        }
      } else {
        error = file.message;
      }
      return {
        ftype: file.ftype,
        fname: file.fname,
        fsize: file.size,
        percent: Number(file.percent),
        failed: !!file.failed,
        success: !!file.complete,
        loading: !!file.uploading,
        error: error,
        spaceFullErr: spaceFullErr,
        sizeLimitErr: sizeLimitErr,
        origin: file
      };
    }
  },
  mixins: [Emitter, uploadMixin],
  props: {
    containerID: {
      type: String
    },
    groupID: {
      type: Number,
      "default": 0
    },
    folderID: {
      type: Number,
      "default": 0
    },
    deviceID: {
      type: Number,
      "default": 0
    },
    userInfo: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    config: {
      type: Object,
      "default": function _default() {
        return {
          enableMultiple: true,
          enableDrag: true,
          enableButton: true
        };
      }
    }
  },
  data: function data() {
    return {
      lang_open: t('logic.Upload.open'),
      singleUploading: false,
      // 单文件上传中
      teamInfo: [],
      // 团队信息
      files: [],
      // 上传文件信息列表
      // 上传状态
      total: {
        queue: 0,
        success: 0,
        fail: 0
      },
      // 上传面板状态
      status: {
        show: false,
        fold: false
      },
      // 上传面板bottom
      bottom: -440,
      zIndex: 1999,
      // 上传插件对象
      PLUploader: null,
      // 上传路径对象
      path: {
        fileid: 0,
        groupid: 0,
        parentid: 0,
        filename: '',
        // 旧的文件名, 上传新版本用
        isNewVersion: false,
        // 是否上传新版本
        directory: '' // 上传文件所在的目录，设置打开目录用到
      },
      //
      hasUpdatedPaths: [],
      // 文件被移除
      removedFiles: [],
      // 判断新版本文件类型是否一致
      isMatchType: true,
      // 手动取消上传的文件id集合
      manualCancelIDs: []
    };
  },
  computed: {
    singleFile: function singleFile() {
      if (this.files.length) {
        return this.files[this.files.length - 1];
      }
      return '';
    },
    tooltipsPermission: function tooltipsPermission() {
      return this.teamInfo.user_role !== 'read_member';
    },
    isSecretExpired: function isSecretExpired() {
      // 私密文件夹权限是否过期
      return this.userInfo.vip_level < 20 && this.teamInfo.type === 'secret';
    },
    uploadFold: function uploadFold() {
      return this.status.fold;
    },
    uploadStyle: function uploadStyle() {
      return {
        bottom: "".concat(this.bottom, "px"),
        zIndex: "".concat(this.zIndex)
      };
    }
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var container;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.getTeamInfo();
          case 2:
            if (_this.containerID) {
              container = document.getElementById(_this.containerID);
              container.appendChild(_this.$el);
            } else {
              document.body.appendChild(_this.$el);
            }
            _this.initPLUpload();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    onClose: function onClose() {
      var _this2 = this;
      var queue = this.total.queue;
      if (queue > 0) {
        MessageBox.confirm(t('logic.Upload.confirm'), t('logic.Upload.tips'), {
          confirmButtonText: t('logic.Upload.close'),
          cancelButtonText: t('logic.Upload.cancel'),
          type: 'warning'
        }).then(function () {
          _this2.cancelTasks();
          _this2.showPanel(false);
        })["catch"](function () {});
      } else {
        this.showPanel(false);
      }
    },
    onToggle: function onToggle() {
      this.status.fold = !this.status.fold;
    },
    onCancelTask: function onCancelTask(args) {
      this.cancelTasks(Array.from(args)[0].id);
    },
    showPanel: function showPanel(show) {
      this.status.show = show;
      this.status.fold = false;
      if (show) {
        this.bottom = 30;
      } else {
        this.bottom = -440;
      }
    },
    cancelTasks: function cancelTasks(id) {
      var _this3 = this;
      this.PLUploader.stop();
      var cancelIDs;
      if (id) {
        cancelIDs = [id];
      } else {
        cancelIDs = this.files.filter(function (file) {
          return !file.failed && file.uploading;
        }).map(function (file) {
          return file.id;
        });
      }
      this.manualCancelIDs = this.manualCancelIDs.concat(cancelIDs);
      cancelIDs.forEach(function (id) {
        _this3.PLUploader.removeFile(id);
      });
      this.PLUploader.start();
    }
  }
};

Upload.install = function (Vue) {
  Vue.component(Upload.name, Upload);
};

export { Upload as default };
